/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import FlexBox from '../common/FlexBox'
import message from '../common/Message'
import Icon from '../../components/common/Icon'
import NetWork, { Cycle, getNodeText } from '../common/NetWork'

import zIndex from '../../utils/zIndexScale'
import { savedNetwork } from '../../utils/httpRequest'

const MobileMenuLayout = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${zIndex.mobileLayout};
`

const MobileMenu = styled.div`
  width: 300px;
  background: #12161c;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  font-size: 16px;
  padding-top: 50px;
  transform: ${({ hide }) => (!hide ? 'translate(0,0)' : 'translate(100%,0)')};
  transition: transform 0.3s linear;
  animation: bounce 0.3s linear;
  ul {
    margin-left: 40px;
    border-bottom: 1px solid #212833;
    padding: 10px 0;
    li.current {
      color: #f0b90b;
      &:before {
        content: ' ';
        position: absolute;
        display: block;
        height: 2px;
        width: 12px;
        left: 0;
        bottom: 6px;
        background: #f0b90b;
      }
    }
    li {
      height: 40px;
      line-height: 40px;
      position: relative;
      a {
        height: 100%;
        display: block;
        color: inherit;
        font-size: 16px;
        &:hover {
          text-decoration: none;
        }
      }
    }
    li.withSubMenus {
      height: auto;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 40px;
    right: 0;
  }
  .docs {
    margin-left: 30px;
    a {
      color: #848e9c;
      font-size: 12px;
    }
  }
  .forums {
    margin-left: 30px;
    a {
      color: #848e9c;
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    display: block;
    .subMenus {
      display: block;
      position: relative;
      top: 0;
      li {
        text-align: left;
      }
    }
  }

  @keyframes bounce {
    0% {
      transform: translateX(100%);
    }
    40% {
      transform: translateX(50%);
    }
    100% {
      transform: translateX(0%);
    }
  }
`

const MenuInfo = styled.div`
  position: relative;
`

const WalletInfo = styled.div`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  padding-left: 30px;
  margin-bottom: 20px;
  .address-info {
    line-height: 20px;
    margin-left: 10px;
    h2 {
      font-size: 18px;
    }
  }
  .address {
    width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 10px;
    color: #848e9c;
  }
`

const CloseWrap = styled.div`
  position: absolute;
  right: 15px;
  top: 0;
  &:before {
    content: ' ';
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: -20px;
    width: 60px;
  }
`

const NetworkNodes = styled.div`
  padding-left: 40px;
  margin-bottom: 30px;
  p {
    font-size: 13px;
    color: #48515d;
  }
  .wrap {
    line-height: 6px;
    span {
      margin-left: 5px;
    }
  }
`

class Menu extends PureComponent {
  static propTypes = {
    closeWallet: PropTypes.func,
    close: PropTypes.func,
    isIpValid: PropTypes.bool,
    address: PropTypes.string,
  }

  static defaultProps = {
    closeWallet: () => {},
    close: () => {},
    address: '',
    isIpValid: true,
  }

  constructor(props) {
    super(props)
    this.state = {
      path: '/',
      hide: false,
      showNodes: false,
      menuGroups: [
        {
          group: 'one',
          menus: [{ text: 'Markets', path: '/' }, { text: 'Exchange', path: '/trade' }],
        },
        {
          group: 'two',
          menus: [
            { text: 'Balances', path: '/balances' },
            { text: 'Open Orders', path: '/openOrders' },
            { text: 'History', path: '/history' },
          ],
        },
        {
          group: 'three',
          menus: [
            { text: 'Change Wallet', path: '/unlock' },
            { text: 'Create New Wallet', path: '/create' },
          ],
        },
      ],
      notLoginMenuGroup: [
        {
          group: 'one',
          menus: [{ text: 'Markets', path: '/' }, { text: 'Exchange', path: '/trade' }],
        },
        {
          group: 'three',
          menus: [
            { text: 'Create New Wallet', path: '/create' },
            { text: 'Unlock Wallet', path: '/unlock' },
          ],
        },
      ],
    }
  }

  layoutRef = React.createRef()

  componentDidMount() {
    const {
      location: { pathname },
    } = this.props
    const [, path] = pathname.split('/')
    this.setState({ path: `/${path}`, currentNetWork: savedNetwork })
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
  }

  _clickMenu = path => {
    const { history } = this.props
    history.push(path)
  }

  _buildMenus = () => {
    const { menuGroups, path, notLoginMenuGroup } = this.state
    const { address, isIpValid } = this.props
    const groups = !!address ? menuGroups : notLoginMenuGroup
    const result = []
    groups.forEach(group => {
      if (group.group === 'three' && !isIpValid) return
      const menus = group.menus.map((menu, index) => {
        return (
          <li
            className={path === menu.path ? 'current' : ''}
            key={index}
            onClick={() => {
              this._clickMenu(menu.path)
            }}
          >
            {menu.text}
          </li>
        )
      })

      result.push(<ul key={group.group}>{menus}</ul>)
    })

    return result
  }

  _copyAddress = () => {
    message.info('copy success')
  }

  _hide = () => {
    const { close } = this.props
    this.setState({ hide: true })
    setTimeout(() => {
      close && close()
    }, 100)
  }

  _clickLayout = ev => {
    const { target } = ev
    if (target === this.layoutRef.current) {
      this._hide()
    }
  }

  _showNodes = () => {
    this.setState({ showNodes: true, hide: true })
  }

  _hideNodes = () => {
    this.setState({ showNodes: false })
    this._hide()
  }

  render() {
    const { address, closeWallet } = this.props
    const { hide, showNodes, currentNetWork } = this.state
    const menuElements = this._buildMenus()
    const networkText = getNodeText(currentNetWork)
    return (
      <MobileMenuLayout ref={this.layoutRef} onClick={this._clickLayout}>
        <MobileMenu hide={hide}>
          <CloseWrap onClick={this._hide}>
            <Icon type="close" size="20" />
          </CloseWrap>
          <WalletInfo show={!!address}>
            <Icon type="account" size="40" />
            <div className="address-info">
              <h2>Wallet</h2>
              <FlexBox>
                <div className="address">{address}</div>
                <CopyToClipboard text={address} onCopy={this._copyAddress}>
                  <span title="copy address">
                    <Icon type="copy" />
                  </span>
                </CopyToClipboard>
              </FlexBox>
            </div>
          </WalletInfo>
          <NetworkNodes onClick={this._showNodes}>
            <p>Choose Node</p>
            <FlexBox className="wrap">
              <Cycle />
              <span>{networkText}</span>
              <span>▾</span>
            </FlexBox>
          </NetworkNodes>
          <MenuInfo>{menuElements}</MenuInfo>
          <FlexBox className="footer">
            {address && <div onClick={closeWallet}>Close Wallet</div>}
            <div className="docs">
              <a href="https://docs.binance.org/" target="_blank" rel="noopener">
                Docs/FAQ
              </a>
            </div>
            <div className="forums">
              <a href="https://community.binance.org/" target="_blank" rel="noopener">
                Forums
              </a>
            </div>
          </FlexBox>
        </MobileMenu>
        {showNodes && <NetWork close={this._hideNodes} />}
      </MobileMenuLayout>
    )
  }
}

export default withRouter(Menu)
